var BUTTON = 'pricing-btn text-center text-uppercase fw-bold';
export var PRIMARY_BUTTON = "".concat(BUTTON, " pricing-btn-primary d-block w-100");
export var OUTLINE_BUTTON = "".concat(BUTTON, " pricing-btn-outline d-block w-100");
export var COMPACT_BUTTON = "".concat(BUTTON, " pricing-btn-compact d-inline-block text-nowrap");